/** Flow keys a tenant can contract — must mirror the backend's VALID_FLOW_KEYS. */
export const SCHEDULING_FLOWS = ['new_appointment', 'query_appointment'];
export const SALES_FLOWS = ['sales', 'sales_catalog'];
/** Any conversational flow: pages like Chats only make sense when a bot talks. */
export const BOT_FLOWS = [...SCHEDULING_FLOWS, ...SALES_FLOWS];
